import { createSelector } from "reselect";
import { UserType } from "../../entities/User";
import { TRootState } from "../reducers/RootReducer";

export const selectUser = (store: TRootState) => store.user.user;

export const isLoggedIn = createSelector(
	selectUser,
	user => user.type !== UserType.Unknown
);

/**
 * Gets the type of the current user.
 * Throws an exception if no one is logged in.
 */
export const selectUserType = createSelector(
	selectUser,
	user => user.type
);

/**
 * Returns true iff user is a customer without company details.
 */
export const customerDetailsRequired = createSelector(
	selectUser,
	user => user.type === UserType.Customer && false
	// 	(data.user.organisationAddress == null ||
	// 		data.user.organisationId == null ||
	// 		data.user.organisationName == null)
);
